export default __webpack_public_path__ + "static/media/work-2.200263e3.jpg";